import { EditChildComponent } from './edit-child/edit-child.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { SearchChildrenComponent } from './search-children/search-children.component';
import { CourseHistoryComponent } from './edit-child/course-history/course-history.component';
import { InaComponent } from './edit-child/ina/ina.component';
import { SearchGroupSchoolEnrollmentsComponent } from './search-group-school-enrollments/search-group-school-enrollments.component';
import { SearchGroupCommunicationEventsComponent } from './search-group-communication-events/search-group-communication-events.component';
import { EditINAComponent } from './edit-child/ina/edit-ina/edit-ina.component';
import { RouteGuardService } from 'src/app/guards/route-guard.service';
import { SearchGroupServicesComponent } from './search-group-services/search-group-services.component';
import { ChildrenDeduplicationSummaryComponent } from './children-deduplication/children-deduplication-summary/children-deduplication-summary.component';
import { ChildrenDeduplicationResolvedComponent } from './children-deduplication/children-deduplication-resolved/children-deduplication-resolved.component';
import { ChildrenDeduplicationUnresolvedComponent } from './children-deduplication/children-deduplication-unresolved/children-deduplication-unresolved.component';
import { ChildrenDeduplicationRegionComponent } from './children-deduplication/children-deduplication-region/children-deduplication-region.component';
import { ViewChildComponent } from './view-child/view-child.component';
import { ChildrenDeduplicationMergeComponent } from './children-deduplication/children-deduplication-merge/children-deduplication-merge.component';
import { ResolveSSIDComponent } from './resolve-ssid/resolve-ssid.component';
import { UnresolvedComponent } from './resolve-ssid/unresolved/unresolved.component';
import { ResolvedComponent } from './resolve-ssid/resolved/resolved.component';
import { ResolvedMatchTaskComponent } from './resolve-ssid/resolved-match-task/resolved-match-task.component';

const routes: Routes = [
    {
        path: 'search',
        component: SearchChildrenComponent,
        canActivate: [AuthGuard] // , RouteGuardService
    },
    {
        path: 'edit/:studentId',
        component: EditChildComponent,
        canActivate: [AuthGuard], // , RouteGuardService
        data: {
            title: 'Edit Child'
        }
    },
    {
        path: 'view/:studentId',
        component: ViewChildComponent,
        canActivate: [AuthGuard], // , RouteGuardService
        data: {
            title: 'View Child'
        }
    },
    {
        path: 'group-enrollment',
        component: SearchGroupSchoolEnrollmentsComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'Group School Enrollment'
        }
    },
    {
        path: 'group-communication-events',
        component: SearchGroupCommunicationEventsComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'Group Communication Events'
        }
    },
    {
        path: 'group-services',
        component: SearchGroupServicesComponent,
        canActivate: [AuthGuard], //, RouteGuardService
        data: {
            title: 'Group Services'
        }
    },
    {
        path: ':childId/ina/:inaId/edit',
        component: EditINAComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Edit Child',
            action: 'edit'
        }
    },
    {
        path: ':childId/ina/:inaId/view',
        component: EditINAComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Edit Child',
            action: 'view'
        }
    },
    {
        path: ':childId/ina/create',
        component: EditINAComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Create Child',
            action: 'create'
        }
    },
    {
        path: 'deduplication',
        component: ChildrenDeduplicationSummaryComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Children Deduplication Summary'
        }
    },
    {
        path: 'deduplication/region/:regionCode',
        component: ChildrenDeduplicationRegionComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Resolve Children Deduplications'
        }
    },
    {
        path: 'deduplication/region/:regionCode/unresolved',
        component: ChildrenDeduplicationUnresolvedComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Unresolved Children Deduplications'
        }
    },
    {
        path: 'deduplication/region/:regionCode/resolved',
        component: ChildrenDeduplicationResolvedComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Resolved Children Deduplications'
        }
    },
    {
        path: 'deduplication/merge',
        component: ChildrenDeduplicationMergeComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Merge Children'
        }
    },
    {
        path: 'resolve-ssid/unresolved/:code',
        component: UnresolvedComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Resolve CALPADS SSIDs'
        }
    },        
    {
        path: 'resolve-ssid/resolved/:code',
        component: ResolvedComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Resolve CALPADS SSIDs'
        }
    },
    {
        path: 'resolve-ssid',
        component: ResolveSSIDComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Resolve CALPADS SSIDs'
        }
    },
    {
        path: 'resolved-match-task',
        component: ResolvedMatchTaskComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Resolve CALPADS SSIDs'
        }
    }


];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ChildrenRoutingModule { }
